import { cn } from '../../lib/utils'

export interface MetricCardProps {
	icon: React.ReactNode
	value: string
	label: string
	change?: string
	trend?: 'up' | 'down'
	variant?: 'default' | 'danger'
	className?: string
}

export function MetricCard({ icon, value, label, change, trend, variant = 'default', className }: MetricCardProps) {
	return (
		<div className={cn(
			'flex flex-col gap-2 rounded-(--radius-md) border border-(--color-border) p-5',
			variant === 'danger' && 'bg-red-50/50',
			className,
		)}>
			<div className="flex items-start justify-between">
				<div className={cn(
					'flex size-10 items-center justify-center rounded-(--radius-md)',
					variant === 'danger' ? 'bg-red-100 text-red-500' : 'bg-(--color-muted) text-(--color-muted-foreground)',
				)}>
					{icon}
				</div>
				{change && (
					<span className={cn(
						'flex items-center gap-0.5 text-sm',
						trend === 'up' ? 'text-(--color-success)' : 'text-(--color-destructive)',
					)}>
						{change}
						<span className="text-xs">{trend === 'up' ? '↗' : '↘'}</span>
					</span>
				)}
			</div>
			<div>
				<p className={cn(
					'text-2xl font-semibold tracking-tight',
					variant === 'danger' ? 'text-(--color-destructive)' : 'text-(--color-foreground)',
				)}>
					{value}
				</p>
				<p className="text-sm text-(--color-muted-foreground)">{label}</p>
			</div>
		</div>
	)
}
